<template>
	<div class="pagination" v-if="!isLoading">
		<button
			class="big-btn"
			v-if="totalPages > 1 && showPages.length && showPages[0] != 1"
			@click="backPages"
		>
			Anterior
		</button>
		<button
			v-for="btn in showPages"
			:class="currentPage == btn ? 'active' : ''"
			:key="btn"
			@click="tableRequest(btn)"
		>
			{{ btn }}
		</button>
		<span
			class="dots"
			v-if="
				totalPages > 1 &&
				alwaysShowLast &&
				currentPage != totalPages &&
				currentPage + 5 <= totalPages &&
				showPages[showPages.length - 1] != totalPages
			"
		>
			...
		</span>
		<button
			v-if="
				totalPages > 1 &&
				alwaysShowLast &&
				currentPage != totalPages &&
				currentPage + 5 <= totalPages &&
				showPages[showPages.length - 1] != totalPages
			"
			@click="tableRequest(totalPages)"
		>
			{{ totalPages }}
		</button>
		<button
			class="big-btn"
			v-if="totalPages > 1 && showPages.length && showPages[showPages.length - 1] != totalPages"
			@click="morePages"
		>
			Próxima
		</button>
	</div>
</template>

<script>
export default {
	name: 'Pagination',
	props: {
		isLoading: {
			default: false,
		},
		totalPages: {
			default: 5,
		},
		currentFromReq: {
			default: 1,
		},
		alwaysShowLast: {
			default: false,
		},
	},
	data: () => ({
		showPages: [],
		newTotalPages: null,
		currentPage: 1,
	}),
	mounted() {
		this.configPagination(this.totalPages);
	},
	methods: {
		configPagination(param) {
			this.showPages = [];

			if (this.currentFromReq != 1) {
				this.currentPage = this.currentFromReq;
			}

			if (param > 6 && this.currentFromReq != param) {
				for (let i = this.currentPage; i <= param && i; i++) {
					if (i == this.currentPage + 5) {
						return;
					} else {
						this.showPages.push(i);
					}
				}
				if (this.showPages.length < 5) {
					for (let i = this.showPages[this.showPages.length - 1]; i >= 1; i--) {
						if (this.showPages.length != 5 && !this.showPages.includes(i)) {
							this.showPages.push(i);
						}
					}
				}
				this.showPages.sort((a, b) => {
					return a - b;
				});
			} else if (param > 6 && this.currentFromReq == param) {
				for (let i = this.currentPage; i <= param; i--) {
					if (i == this.currentPage - 5) {
						return;
					} else {
						this.showPages.push(i);
						this.showPages.sort((a, b) => {
							return a - b;
						});
					}
				}
			} else {
				for (let i = 1; i <= param; i++) {
					this.showPages.push(i);
				}
			}
		},
		backPages() {
			let firstIndex = this.showPages[0];

			this.showPages.pop();

			if (firstIndex != 1) {
				this.showPages.unshift(firstIndex - 1);
			}
		},
		tableRequest(page) {
			this.currentPage = page;

			const params = {
				params: this.currentPage,
				type: 'pagination',
			};

			this.$emit('tableRequest', params);
		},
		morePages() {
			let lastIndex = this.showPages[4];

			this.showPages.shift();

			if (lastIndex != this.totalPages) {
				this.showPages.push(lastIndex + 1);
			}
		},
		getCurrentPage() {
			return this.currentPage;
		},
	},
	watch: {
		totalPages(newValue) {
			if (newValue) {
				this.newTotalPages = newValue;
				this.configPagination(newValue);
			}
		},
	},
};
</script>

<style scoped lang="scss">
@import 'Pagination.scss';
</style>
